// auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SecurityContextService } from '@services/security_context.service';

@Injectable({
  providedIn: 'root',
})
export class TrustedGuard implements CanActivate {
  constructor(
    private _router: Router,
    private securityContextService: SecurityContextService,
  ) {}
  canActivate(): boolean {
    if (this.securityContextService.isTrustedUser()) {
      return true;
    } else {
      this._router.navigate(['home']);
      return false;
    }
  }
}
